/**
 * Document ready
 */

const maksimerTabs = () => {
	const tabs = document.querySelectorAll('.accordion__title');
	if (tabs) {
		tabs.forEach((tab) => {
			tab.addEventListener('click', (tabEvent) => {
				tabEvent.currentTarget.parentNode.classList.toggle('--active');
			});
		});
	}
};
maksimerTabs();

/**
 * Cart page coupon code.
 */
jQuery(($) => {
	const maksimerCoupon = () => {
		const link = document.querySelector('.maksimer-coupon-link');
		if (link) {
			const input = document.querySelector(
				'.coupon button[type="submit"]'
			);
			link.addEventListener('click', () => {
				if (link.parentNode.classList.contains('active')) {
					input.click();
				} else {
					link.parentNode.classList.add('active');
				}
			});
		}
	};
	maksimerCoupon();
});
